import React from 'react'
import { getSpaceColor } from './spaceColors'
import { AvailabilityCalendarRoom } from './types'
import { Sidebar, SidebarTitle, SpaceCheckbox, SpaceItem, SpaceName } from './style'

interface SpaceSidebarProps {
  rooms: AvailabilityCalendarRoom[]
  visibleRoomIds: string[]
  spacesLabel: string
  showAllLabel: string
  onToggleAll: () => void
  onToggleRoom: (roomId: string) => void
}

export const SpaceSidebar = ({
  rooms,
  visibleRoomIds,
  spacesLabel,
  showAllLabel,
  onToggleAll,
  onToggleRoom,
}: SpaceSidebarProps): JSX.Element => {
  const allSelected = rooms.length > 0 && visibleRoomIds.length === rooms.length

  return (
    <Sidebar>
      <SidebarTitle>{spacesLabel}</SidebarTitle>
      <SpaceItem>
        <SpaceCheckbox
          $color="var(--grey)"
          checked={allSelected}
          onChange={onToggleAll}
        />
        <SpaceName style={{ fontWeight: 500 }}>{showAllLabel}</SpaceName>
      </SpaceItem>
      {rooms.map((room, index) => (
        <SpaceItem key={room.id}>
          <SpaceCheckbox
            $color={getSpaceColor(room.id, index)}
            checked={visibleRoomIds.includes(room.id)}
            onChange={() => onToggleRoom(room.id)}
          />
          <SpaceName title={room.name}>{room.name}</SpaceName>
        </SpaceItem>
      ))}
    </Sidebar>
  )
}
